<template>
  <div :style="styles" class="core__avatar" :title="username" @click="onclick">
    <img v-if="url&&!loadfailed" :src="url" @error="onError" />
    <img v-else-if="defalutImg&&loadfailed" :src="defalutImg">
    <svg v-else class="fontsvg" width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <text x='50%' y='50%' dx="" fill="white" text-anchor="middle" dominant-baseline="middle">{{text}}</text>
    </svg>
    <!-- </div> -->
  </div>
</template>
<script>
let timer = null
// 该时间间隔内点击才算连续点击（单位：ms）
let waitTime = 500
// 连续点击次数
let num = 0
// 最大连续点击次数
let maxNum = 5
// 上次的点击时间
let lastTime = new Date().getTime()

function lianxudianji(callback) {
  let nowTime = new Date().getTime()
  if (nowTime - lastTime < waitTime) {
    num++
  } else {
    num = 0
  }
  lastTime = nowTime
  if (num >= maxNum) {
    num = 0
    clearTimeout(timer)
    timer = setTimeout(() => {
      callback()
    }, 100)
  }
}

export default {
  name: "core-avatar",
  props: {
    size: {
      type: Number,
      default: 40,
    },
    username: String,
    faceUrl: {
      type: String,
      default: "",
    },
    userid: {
      type: String,
      default: "",
    },
  },
  data() {
    // let user = this.$store.state.core.user
   
    return {
      loadfailed: false,
    }
  },
  watch: {},
  computed: {
    defalutImg() {
      let logoPng = "static/img/logo.png"
      if (this.username == "管理员") return logoPng
      else if (this.username == "我" && this.$app.user.isAdmin) return logoPng
      else return ""
    },
    url() {
      let url = "static/img/userface.jpg"
      
      if (this.faceUrl) url = this.faceUrl
      else if (this.userid) {
        url = this.$store.state.core.getFacebyUserID(this.userid)
      } else if (this.username) {
        url = ""
      }
      return url
    },
    text() {
      if (this.username) {
        return this.username.slice(-2)
      }
    },
    styles() {
      let style = {}
      if (this.size) {
        style["font-size"] = (this.size * 1.0) / 3 + "px"
        style["width"] = this.size + "px"
        style["height"] = this.size + "px"
      }
      return style
    },
  },
  methods: {
    onclick(e) {
      if (e.shiftKey) {
        lianxudianji(async () => {
          await this.$app.http.post("core.sys.refreshLastModifyDt")
          await this.$toast.success("刷新系统时间戳完成")
        })
      }
    },

    onError() {
      this.loadfailed = true
    },
  },
}
</script>
<style lang="scss" >
.core__avatar {
  position: relative;
  user-select: none;
  z-index: 10;
  img: {
    width: 100%;
    height: 100%;
  }

  &:hover {
    z-index: 100;
  }

  .fontsvg {
    background-color: #3696f2;
  }

  &.chatmyself {
    .fontsvg {
      background-color: #4eb164;
      // background-color: #3696f2;
    }
  }

  border-radius: 8px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>